<template>
    <v-card>
        <v-card-title>Statistiche</v-card-title>

        <v-card-text v-if="error">
            <error-badge v-model="error"></error-badge>
        </v-card-text>
        <v-card-text v-else-if="loading" class="text-center">
            <v-progress-circular :width="10" :size="150" color="amber" indeterminate>{{ trans('common.loading')
                }}</v-progress-circular>
        </v-card-text>
        <v-card-text v-else-if="data">

            <h2>Progetti in corso</h2>
            <br>
            <v-row>
                <v-col v-bind="{ xs: 12, sm: 12, lg: 6, }">
                    <h3>Progetti in corso per budget</h3>
                    <apexchart v-if="data.projects.length > 0" type="donut" :options="chart1.options" :series="chart1.series" />
                    <p v-else class="mt-4">Nessun progetto assegnato</p>
                </v-col>
                <v-col v-bind="{ xs: 12, sm: 12, lg: 6, }">
                    <h3>Avanzamento globale progetti</h3>
                    <apexchart v-if="data.projects.length > 0" type="radialBar" :options="chart2.options" :series="chart2.series" />
                    <p v-else class="mt-4">Nessun progetto assegnato</p>

                </v-col>
            </v-row>
            <v-divider class="my-5"></v-divider>

            <h2>Ultimi avanzamenti lavori</h2>
            <apexchart v-if="data.projects.length > 0" type="bar" :options="chart3.options" :series="chart3.series" />
            <p v-else class="mt-4">Nessun progetto assegnato</p>

        </v-card-text>
    </v-card>
</template>

<script>
export default {

    mounted() {
        this.fetchData();
    },
    data() {
        return {
            data: null,

            loading: false,
            error: null,
        }
    },
    computed: {
        chart1() {
            if (!this.data)
                return null;
            let options = {
                labels: [],
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: (s) => {

                            return 'Totale stimato: ' + (s && parseFloat(s) ? "€ " + parseFloat(s).toFixed(2) : "-")
                        },
                    },
                },

                responsive: [
                    {
                        breakpoint: 500,
                        options: {
                            legend: {
                                position: "bottom"
                            }
                        },
                    }
                ],
            };
            let series = [];
            for (let p of this.data.projects) {
                series.push(p.tot_price || 0);
                options.labels.push(p.name);
            }

            return {
                options,
                series,

            };
        },
        chart2() {
            if (!this.data)
                return null;
            let options = {
                labels: [],


                legend: {
                    show: true,

                    labels: {
                        useSeriesColors: true,
                    },
                    markers: {
                        size: 0
                    },
                    formatter: function (seriesName, opts) {
                        return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + '%'
                    },
                    itemMargin: {
                        vertical: 3
                    }
                },
                responsive: [
                    {
                        breakpoint: 500,
                        options: {
                            legend: {
                                position: "bottom"
                            }
                        },
                    }
                ],
            };
            let series = [];
            for (let p of this.data.projects) {
                series.push(p.tot_progress || 0);
                options.labels.push(p.name);
            }

            return {
                options,
                series,
            };
        },
        chart3() {
            if (!this.data)
                return null;
            let options = {
                chart: {
                    height: 'auto'
                },
                xaxis: {
                    categories: [],
                    min: 0,
                    max: 100,
                },
                plotOptions: {
                    bar: {
                        borderRadius: 1,
                        horizontal: true,
                    }
                },
                dataLabels: {

                    formatter: function (val, opts) {
                        return val + '%'
                    },
                },
                tooltip: {
                    y: {
                        show: true,
                        formatter: (v) => `${v}%`,
                    },
                },
            };


            let series = [{
                name: 'SAL del sottotask',
                data: [],
            }];
            for (let p of this.data.last_sals) {
                series[0].data.push(p.sal || 0);
                options.xaxis.categories.push(p.project_name + ' - ' + p.subtask_name);
            }

            return {
                options,
                series,
            };
        },
    },
    methods: {
        async fetchData() {
            this.loading = true;
            this.error = null;
            try {
                let r = await axios.get('/stats');

                if (r.data) {
                    this.data = r.data;
                }
                else {
                    throw "Invalid data received";
                }
            } catch (e) {
                this.error = e;
            }
            this.loading = false;
        },
    }

}
</script>